import './styles/claim.scss';

function Claim() {
    return (
        <div className="claim">
            <div className="claimText">"Die Blindheit der wenigen Begabten ist letztlich unbedeutender als das Ausmaß der Abgestumpfheit der Masse. Aus diesem Grund ist die Begabtheit der wenigen Blinden bedeutender als die Zahl derjenigen, die nur zu sehen glauben."</div>
            <div className="claimQuote">Atlantic Jordan</div>
        </div>
    );
}

export default Claim;
